import { render, staticRenderFns } from "./listPayments.vue?vue&type=template&id=7064bbb8&scoped=true&"
import script from "./listPayments.vue?vue&type=script&lang=js&"
export * from "./listPayments.vue?vue&type=script&lang=js&"
import style0 from "./listPayments.vue?vue&type=style&index=0&id=7064bbb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064bbb8",
  null
  
)

export default component.exports